import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAuth } from "../../hooks/useAuth";

export function WithToken(ComposedComponent) {
  function TokenOutput({
    query,
  }: {
    query: { [key: string]: string };
    pathname: string;
    asPath: string;
  }) {
    const isStateRestored = useSelector(
      (state) => state.setting.isStateRestored
    );
    const { setAuthData } = useAuth();

    function checkAuth() {
      if (query?.auth_token || query?.refresh_token) {
        const reqData = {
          accessToken: query?.auth_token,
          refreshToken: query?.refresh_token,
        };
        setAuthData(reqData);
      }
    }

    useEffect(() => {
      if (isStateRestored) checkAuth();
    }, [isStateRestored]);

    if (!isStateRestored) return null;

    const props = arguments[0] ?? {};
    return <ComposedComponent {...props} />;
  }

  return TokenOutput;
}
